export interface HttpEvent<T> {
  type: string;
}
